import { Component, OnInit, Input, HostListener, ChangeDetectorRef } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from "@angular/router";
import { Subscription } from 'rxjs';
import { MenuService } from '../../services/menu.service';
import { VendorService } from 'src/app/services/vendor.service';
import { environment } from '../../../../environments/environment';
import { UtilsDataService } from 'src/app/services/utils-data.service';
import { LogoService } from '../../services/logo.service';
import { UtilsService } from 'src/app/utils.service';
import { JobSeekerService } from 'src/app/job-seeker/job-seeker.service';

@Component({
  selector: 'app-header-one',
  templateUrl: './header-one.component.html',
  styleUrls: ['./header-one.component.scss']
})
export class HeaderOneComponent implements OnInit {

  @Input() class!: string;
  @Input() themeLogo: string = 'assets/images/logos/final-logo.png'; // Default Logo
  @Input() topbar: boolean = true; // Default True
  @Input() sticky: boolean = false; // Default false
  isLoggedIn = false;
  private loginStatusSubscription!: Subscription;
  //logo: string = 'assets/images/logos/Whiterobe-final-logo.svg'; // Default Logo
  vendorData: any = {}
  public stick: boolean = false;
  myAcountMenu: any = [];
  companyName: string | null = null
  host: string = '';
  hostBarEnable: boolean = false
  companyTitle: any = {}
  logo: string = '';
  isDefaultLogo: boolean = true;
  data: any = {};
  left_menu: number = 1;
  right_body: number = 11;
  expand_menu: boolean = true;
  fullScreenDisplay: boolean = true;
  @Input() menuCustom: any = [];

  constructor(
    private authService: AuthService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private menuService: MenuService,
    private vendorService: VendorService,
    private utilsDataService: UtilsDataService,
    private logoService: LogoService,
    private utilsService: UtilsService,
    private jobSeekerService: JobSeekerService,

  ) {
    this.menuService.menuSubject$.subscribe(menu => {
      console.log("==OBS menu===", menu)
      this.myAcountMenu = menu.my_accounts_menu;
    })

    // if(!environment.production){
    this.hostBarEnable = environment.production;
    this.host = environment.envLabel
    // }
  }

  ngOnInit(): void {
    this.loginStatusSubscription = this.authService.getLoginStatus().subscribe(status => {
      this.isLoggedIn = status;
      this.cdRef.detectChanges(); // Trigger change detection
    });

    if (this.isLoggedIn) {
      this.companyTitle = this.utilsDataService.setCompanyDetails.company_name;
      console.log("title:", this.companyTitle)

    }
    this.logoService.logo$.subscribe((url: string) => {
      console.log('Received logo URL:', url); // ✅ Check this
      this.logo = url && url.trim() !== '' ? url : 'assets/images/logos/final-logo.png';
      this.isDefaultLogo = this.logo.includes('final-logo.png') || this.logo.includes('Whiterobe-final-logo.svg');
    });
    /*  this.logoService.logo$.subscribe((url: string) => {
     this.logo = url;
   }); */

    this.utilsService.profileActionData.subscribe((data: any) => {
      this.data = data.profileData;
      console.log("RRRRR", data);
      //this.setAgentProfile(this.adminData); // Move it here
    });


    this.getMenus()

  }

  ngOnDestroy(): void {
    if (this.loginStatusSubscription) {
      this.loginStatusSubscription.unsubscribe();
    }
  }

  logout(): void {
    this.authService.logout();
    this.vendorService.clearData();
    this.router.navigate(['/']); // Redirect to login page or home page after logout
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    let number = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (number >= 150 && window.innerWidth > 400) {
      this.stick = true;
    } else {
      this.stick = false;
    }
  }

  goTo(link: any) {
    this.router.navigate([link])
  }

  getCompanyDetailsByVendorId() {
    let reqObj = {
      // uuid: this.vendorData.uuid,
    };
    this.vendorService
      .getCompanyDetailsByVendorId(reqObj)
      .subscribe((response: any) => {
        if (response.statusCode == 200) {
          this.companyName = response.data.company_name;
        }
      });
  }

  onLogoError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/images/logos/final-logo.png';
  }

  goToDashboard() {
    const role = this.data.role;

    console.log("role", role);

    switch (role) {
      case 'VENDOR':
        this.router.navigate(['vendor/jobs-dashboard']);
        break;

      case 'VENDOR_EMP':
        this.router.navigate(['/vendor/employee/console']);
        break;

      case 'AGENT':
        this.router.navigate(['/admin/agents-console']);
        break;

      case 'INTERVIEWER':
        this.router.navigate(['/interviewer']);
        break;

      case 'USER':
        this.router.navigate(['job-seeker/new-dashboard']);
        break;

      default:
        console.warn('Unknown role:', role);
        break;
    }
  }

setFullScreen() {
  console.log("clicking",this.jobSeekerService.fullScreenDisplay())
  const newValue = !this.jobSeekerService.fullScreenDisplay();
  this.fullScreenDisplay = newValue

  console.log("clicking new value",newValue)

  this.jobSeekerService.setFullScreenDisplay(newValue);

}


  getMenus() {
    this.menuService.getMenu.subscribe(data => {
      console.log('Menu Items:', data['VENDOR']);
      this.menuCustom = data['menu'];
    });
  }

}
